import { loadAnalytics } from 'modules/analytics';
import { logError } from 'utils/datadog';
import { setConsentGiven } from '../analytics/analytics';

const SERVICE_ID_SEGMENT = 'O97xcRJFR';

export const handleConsentDetails = async (shouldReload: boolean) => {
  try {
    const data = await window.__ucCmp.getConsentDetails();

    const isSegmentConsentGiven =
      !!data.services[SERVICE_ID_SEGMENT]?.consent?.given;

    setConsentGiven(isSegmentConsentGiven);

    if (isSegmentConsentGiven) {
      await loadAnalytics();
      window.__ucCmp.refreshScripts();
    } else if (shouldReload) {
      window.location.reload();
    }
  } catch (error) {
    logError('Error handling consent details', error);
  }
};

export const handleConsentEvent = (shouldReload: boolean = false) => {
  handleConsentDetails(shouldReload).catch(error => {
    logError('Error handling consent event', error);
  });
};

// Stable reference: an inline arrow here could never be removed again, so every extra
// initializeConsentManager call would stack another handler — and a duplicated UC_CONSENT
// handler reloads the page twice on every consent change.
const onConsentChanged = () => handleConsentEvent(true);

export const initializeConsentManager = () => {
  handleConsentEvent();
  // remove-then-add keeps this idempotent; init can legitimately run more than once per
  // page load (SDK already up + a re-armed UC_UI_INITIALIZED listener).
  window.removeEventListener('UC_CONSENT', onConsentChanged);
  window.addEventListener('UC_CONSENT', onConsentChanged);
};
